import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { JSONApiDataObject, ReduxEntity } from 'Douleutaras/types';
import { BsdirTopPro } from 'Douleutaras/types/bsdir';
import { RootState } from 'Douleutaras/redux/store';

const bsdirTopProsAdapter = createEntityAdapter<JSONApiDataObject<BsdirTopPro>>({
  selectId: item => item.id
});

export const bsdirTopProsSlice = createSlice({
  name: 'bsdirTopPros',
  initialState: bsdirTopProsAdapter.getInitialState({
    loading: false,
    error: false,
    meta: {},
    entities: {}
  } as ReduxEntity<BsdirTopPro>),
  reducers: {
    bsdirTopProsAdded: (state, action) => {
      bsdirTopProsAdapter.setMany(state, action.payload);
    }
  }
});

export const bsdirTopProsSelectors = bsdirTopProsAdapter.getSelectors(
  (state: RootState) => state.bsdir.topPros);
export default bsdirTopProsSlice.reducer;
